import { render, staticRenderFns } from "./ajTable.vue?vue&type=template&id=38acd3f5&scoped=true"
import script from "./ajTable.vue?vue&type=script&lang=js"
export * from "./ajTable.vue?vue&type=script&lang=js"
import style0 from "./ajTable.vue?vue&type=style&index=0&id=38acd3f5&prod&scoped=true&lang=css"
import style1 from "./ajTable.vue?vue&type=style&index=1&id=38acd3f5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38acd3f5",
  null
  
)

export default component.exports